import { ViewModel, View, ObservableArray } from "binder";
import { getAsBoolean, getAsNumber } from "../../../utilities";
import { ColumnFilter } from "../columnFilter";
import  { NumericFilterView } from "./numericFilter-view"
import { stringIsNullOrEmpty } from "src/common/utilities";

export class NumericFilterViewModel extends ColumnFilter{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.enumFilters = ObservableArray.create<singleEnumFilter>();
        this.showEnumFilters = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new NumericFilterView();
    }
    public getTypeId(): string {
        return "VM-E29D4544-4B80-4729-9101-FEF44014A722"
    }
    public set largerThan(v: number) { this._largerThan = getAsNumber(v,true); } public get largerThan(): number { return this._largerThan;} private _largerThan: number;
    public set smallerThan(v: number) { this._smallerThan = getAsNumber(v,true); } public get smallerThan(): number { return this._smallerThan;} private _smallerThan: number;
    public set applylarger(v: boolean) { this._applylarger =getAsBoolean(v); } public get applylarger(): boolean { return this._applylarger;} private _applylarger: boolean;
    public set applySmaller(v: boolean) { this._applySmaller =getAsBoolean(v); } public get applySmaller(): boolean { return this._applySmaller;} private _applySmaller: boolean;
    public set enumfilter(v: string) { 
        this._enumfilter = v;
        if(stringIsNullOrEmpty(v)==false){
            try{
                let buffer = JSON.parse(v);
                this.enumFilters.update(...buffer.map(x=>{
                    let r = new singleEnumFilter(this);
                    r.name = x.name;
                    r.minValue = x.minValue;
                    r.maxValue = x.maxValue;                
                    return r;
                }));
                if(this.enumFilters.length>0){
                    this.showEnumFilters = true;
                }
            }catch{
                console.error('error in creating enum filters in numeric filter.')
            }
        } 
    } public get enumfilter(): string { return this._enumfilter;} private _enumfilter: string;
    public set enumFilters(v: ObservableArray<singleEnumFilter>) { this._enumFilters = v; } public get enumFilters(): ObservableArray<singleEnumFilter> { return this._enumFilters;} private _enumFilters: ObservableArray<singleEnumFilter>;
    public set showEnumFilters(v: boolean) { this._showEnumFilters =getAsBoolean(v); } public get showEnumFilters(): boolean { return this._showEnumFilters;} private _showEnumFilters: boolean;
    

}

export class singleEnumFilter extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.isSelected = false;
    }
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set minValue(v: number) { this._minValue = v; } public get minValue(): number { return this._minValue;} private _minValue: number;
    public set maxValue(v: number) { this._maxValue = v; } public get maxValue(): number { return this._maxValue;} private _maxValue: number;
    
}
